import "./App.css";
import { useEffect } from "react";
import Match from "./views/match";
import { BrowserRouter as Router } from "react-router-dom";
import ScreenSizeProvider from "./contexts/ScreenSizeContext";
import OnlineMatchProvider from "./contexts/OnlineMatchContext";
import GameSoundProvider from "./contexts/SoundContext";

function App() {
   useEffect(() => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isIOS) {
      document.getElementById('fullscreen')?.remove();
    }
  }, [])
  return (
    <div className="App">
      <button onClick={() => {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else {
          document.documentElement.requestFullscreen();
        }
        }}>Fullscreen</button>
      <Router>
        <ScreenSizeProvider>
          <GameSoundProvider>
            <OnlineMatchProvider>
              <Match />
            </OnlineMatchProvider>
          </GameSoundProvider>
        </ScreenSizeProvider>
      </Router>
    </div>
  );
}

export default App;
